import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calendar, Phone } from 'lucide-react';

/**
 * Mobile-only sticky booking bar.
 * - Visible only on screens < md (768px)
 * - Hidden on the /book page itself (no need for a "Book Now" button when they're already there)
 * - Shows two actions: Book (primary) + Text (secondary)
 * - Slides in from below on scroll for a smoother UX
 */
const StickyMobileBookBar = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show once the user has scrolled a bit — feels less intrusive on first load
    const handleScroll = () => setVisible(window.scrollY > 120);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Hide on the booking page itself
  if (location.pathname.startsWith('/book')) return null;

  return (
    <div
      className={`md:hidden fixed inset-x-0 bottom-0 z-40 transition-transform duration-500 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
      data-testid="sticky-mobile-book-bar"
      aria-hidden={!visible}
    >
      <div className="mx-3 mb-3 rounded-2xl bg-white/95 backdrop-blur-md shadow-2xl border border-gray-100">
        <div className="flex items-stretch gap-2 p-2">
          <Link
            to="/book"
            className="flex-1 flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 active:bg-teal-800 text-white font-medium rounded-xl px-4 py-3 text-sm transition-colors"
            data-testid="sticky-book-btn"
          >
            <Calendar className="w-4 h-4" />
            Book Now
          </Link>
          <a
            href="sms:+14156789133"
            className="flex items-center justify-center gap-2 bg-gray-900 hover:bg-black active:bg-black text-white font-medium rounded-xl px-4 py-3 text-sm transition-colors"
            data-testid="sticky-text-btn"
            aria-label="Text Ayumi"
          >
            <Phone className="w-4 h-4" />
            Text
          </a>
        </div>
      </div>
    </div>
  );
};

export default StickyMobileBookBar;
